import React, { Component } from 'react';
import styles from '../../../screens/PlanOverview/DetailsOverview.module.css';
import { StaticAddress } from '../../Vendor/Apple/IntakeLoss/CountryAddressForms';
import NumberFormat from 'react-number-format';

export default function DetailsDisplayBlock({
    eventType,
    buyoutAmount,
    title,
    address,
    clientId,
    countryCode,
    phone,
    email
}) {
    return (
        <>
            <h3 className={styles.claimDetailsH6}>{title}</h3>
            <div>
                {address && (
                    <StaticAddress
                        addressData={address}
                        showName={true}
                        clientId={clientId}
                        countryCode={countryCode}
                        showContactDetails={true}
                        phone={phone}
                        email={email}
                    />
                )}
                {eventType === 'buyout' && (
                    <p className={styles.buyoutDetails}>
                        Reimbursement Amount:{' '}
                        <NumberFormat
                            value={buyoutAmount ?? 0}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            decimalScale={2}
                            fixedDecimalScale={true}
                        />
                    </p>
                )}
            </div>
        </>
    );
}
